import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ScriptLoader = /*#__PURE__*/function () {
  function ScriptLoader() {
    _classCallCheck(this, ScriptLoader);
  }

  _createClass(ScriptLoader, null, [{
    key: "load",
    value: // Object to track script loading status.

    /**
     * Load a script onto the page.
     * @param {*} url The URL of the script to load.
     * @param {*} callback A function to be called on success/failure of the load of the script.
     */
    function load(url, callback) {
      // If the script is already loaded/loading.
      if (ScriptLoader.scriptStatus[url]) {
        // If the script is already loaded, trigger the callback with an loaded state.
        if (ScriptLoader.isLoaded(url)) {
          callback(false);
          return;
        } // If the script failed to load due to an error, trigger the callback with an error state.


        if (ScriptLoader.isError(url)) {
          callback(true);
          return;
        } // If it is loading but not done yet, add the callback to the callbacks array.


        ScriptLoader.scriptStatus[url].callbacks.push(callback);
        return;
      } // The script has not started loading yet. Create the script tag.


      var s = document.createElement('script');
      s.src = url; // Handle script load completion.

      s.onload = function () {
        ScriptLoader.onLoad(url);
      }; // Handle script load errors.


      s.onerror = function (error) {
        ScriptLoader.onError(url, !!error);
      }; // Attach the script to the page.


      document.body.appendChild(s); // Add the loading status to the status object.

      ScriptLoader.scriptStatus[url] = {
        loaded: false,
        error: false,
        callbacks: [callback]
      };
    }
    /**
     * Check if a script is already loaded onto the page.
     * @param {*} url
     */

  }, {
    key: "isLoaded",
    value: function isLoaded(url) {
      return ScriptLoader.scriptStatus[url] && ScriptLoader.scriptStatus[url].loaded;
    }
    /**
     * Check if a script failed to load for some reason.
     * @param {*} url
     */

  }, {
    key: "isError",
    value: function isError(url) {
      // If the script is not loaded yet, then I guess we do not have an error yet.
      if (!ScriptLoader.isLoaded(url)) {
        return false;
      }

      return ScriptLoader.scriptStatus[url].error;
    } // Callback to handle the onload from the script tag.

  }, {
    key: "onLoad",
    value: function onLoad(url) {
      ScriptLoader.scriptStatus[url].loaded = true;
      ScriptLoader.triggerCallbacks(url);
    } // Callback to handle the onerror from the script tag.

  }, {
    key: "onError",
    value: function onError(url, error) {
      ScriptLoader.scriptStatus[url].error = error;
      ScriptLoader.triggerCallbacks(url);
    } // Trigger all of the callbacks for the URL with the success or failure status.

  }, {
    key: "triggerCallbacks",
    value: function triggerCallbacks(url) {
      var script = ScriptLoader.scriptStatus[url];
      script.callbacks.forEach(function (callback) {
        return callback(script.error);
      });
    }
  }]);

  return ScriptLoader;
}();

_defineProperty(ScriptLoader, "scriptStatus", {});

export { ScriptLoader as default };